import { InjectionToken, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SectionOptionsSettings } from './section-options.component';

export const MORE_FILTERS_CUSTOM_OPTIONS_TOKEN = new InjectionToken<MoreFiltersCustomOptionsService>(
  'MoreFiltersCustomOptions'
);

export interface MoreFiltersCustomOptionsService<S = unknown> {
  selectedValues: S;
  onResetClick?: (params?: unknown) => void;
  getOptions(): Observable<SectionOptionsSettings[]>;
  onApplyChanges?(params?: unknown): void;
  setOptions?(params?: unknown): void;
  clearSelectedValues?(): void;
}

@Injectable()
export class DefaultMoreFiltersCustomOptionsService implements MoreFiltersCustomOptionsService {
  selectedValues: unknown;
  getOptions(): Observable<SectionOptionsSettings[]> {
    return of(null);
  }
}

export const isImplementingMoreFiltersCustomOptionsService = (service: any) => {
  return service.selectedValues !== undefined && service.getOptions !== undefined;
};
